// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GFRo5k7Ion {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.GFRo5k7Ion h4 {
  line-height: 3em;
}
.GFRo5k7Ion .TwNrXwqsy4 {
  float: left;
  width: 100%;
}
.GFRo5k7Ion .AW9gXy_mqM {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.GFRo5k7Ion .AW9gXy_mqM:hover {
  cursor: pointer;
}
.GFRo5k7Ion .AW9gXy_mqM:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.lp5fMkZZUC .gokO9AZjSS:focus {
  outline: none;
}
.lp5fMkZZUC .gokO9AZjSS.k6okVIGihX.Aqb9sjRPe9 {
  background: #375A88;
}
.lp5fMkZZUC .gokO9AZjSS.k6okVIGihX.Aqb9sjRPe9 span {
  color: #fff;
}
.lp5fMkZZUC .Aqb9sjRPe9 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.lp5fMkZZUC .Aqb9sjRPe9:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.lp5fMkZZUC input {
  height: 38px;
  min-width: 220px;
}
.AW9gXy_mqM.R7H_hpxN0n {
  background: #410102;
}
.AW9gXy_mqM.LDQybne1Iq {
  background: #911318;
}
.AW9gXy_mqM.XYCK0TdahU {
  background: #D8293B;
}
.AW9gXy_mqM.A9su_054Gx {
  background: #F2373C;
}
.AW9gXy_mqM.NpKc1Kz_pd {
  background: #FC4448;
}
.AW9gXy_mqM.RKS19c5KeT {
  background: #ED535E;
}
.AW9gXy_mqM.H68INUgIWp {
  background: #E34926;
}
.AW9gXy_mqM.plgSxsy9LL {
  background: #FC562B;
}
.AW9gXy_mqM.cSAzkg6p11 {
  background: #FC6722;
}
.AW9gXy_mqM.FFJHUyfcXX {
  background: #FD7F24;
}
.AW9gXy_mqM.OjuGwbigQO {
  background: #FD8D26;
}
.AW9gXy_mqM.sf8CZhYPU3 {
  background: #EC9C3E;
}
.AW9gXy_mqM.mflrNT0Tu1 {
  background: #0e673a;
}
.AW9gXy_mqM.xnpN8yV5kt {
  background: #208740;
}
.AW9gXy_mqM.ou7WZZCdrB {
  background: #239718;
}
.AW9gXy_mqM.VljSyFJSEa {
  background: #55A84D;
}
.AW9gXy_mqM.pJ9ckYYz8F {
  background: #4BBE5A;
}
.AW9gXy_mqM.HXKGzwvo_B {
  background: #0CCA6A;
}
.AW9gXy_mqM.CXXwW4Ivqf {
  background: #0A3C64;
}
.AW9gXy_mqM.kq8Hnsd3UY {
  background: #0d487a;
}
.AW9gXy_mqM.sWN7eG77Ak {
  background: #10538d;
}
.AW9gXy_mqM.LCuh0vbUa5 {
  background: #115A99;
}
.AW9gXy_mqM.jO_GlnTwuu {
  background: #3387E2;
}
.AW9gXy_mqM.oyctR0glwM {
  background: #1BA9CF;
}
.AW9gXy_mqM.QDGdWCUzrc {
  background: #d27c02;
}
.AW9gXy_mqM.BmYWT4MgdN {
  background: #fb9402;
}
.AW9gXy_mqM.jQzCjLEjFW {
  background: #FD9B30;
}
.AW9gXy_mqM.yJ4eOq0nA2 {
  background: #FDBE2D;
}
.AW9gXy_mqM.N3xsd1Ug4W {
  background: #FED831;
}
.AW9gXy_mqM.cpJXGKDbyO {
  background: #FFFD38;
}
.AW9gXy_mqM.xrBgRvhBfx {
  background: #2D215C;
}
.AW9gXy_mqM.caIy3E_yhD {
  background: #483C83;
}
.AW9gXy_mqM.oHO8PRe1r0 {
  background: #58518d;
}
.AW9gXy_mqM.n5qnVBW69M {
  background: #7068A9;
}
.AW9gXy_mqM.jOmzNtj2pH {
  background: #7f78b2;
}
.AW9gXy_mqM.iUMnK3we3y {
  background: #8f88bc;
}
.AW9gXy_mqM.RVtpee7MoM {
  background: #000;
}
.AW9gXy_mqM.UtcvSENCac {
  background: #282626;
}
.AW9gXy_mqM.Q2hUN1QtEI {
  background: #242222;
}
.AW9gXy_mqM.fv5RqPxJxU {
  background: #353838;
}
.AW9gXy_mqM.rIPuSpvunH {
  background: #666;
}
.AW9gXy_mqM.A3k3VoEQl2 {
  background: #999;
}
.Af2jdI5reb {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.Af2jdI5reb .l45EiPTvYI {
  display: none;
}
.B1vMjMCbPd {
  display: none;
}
.alngoCyDDf {
  font-size: 12px;
}
.b-grid-header:not(:last-child) {
  border-right: 1px solid #ddd !important;
}
.b-hover .b-grid-cell {
  background-color: hsl(47, 100%, 95%) !important;
}
.b-gridbase.b-grid-notextselection .b-grid-cell:not(:last-child) {
  border-right: 1px solid #e1e1e1;
}
.b-grid-cell.b-focused::after {
  display: none;
}
.b-grid-vertical-scroller {
  column-gap: 0;
}
.b-virtual-scrollers ::-webkit-scrollbar {
  height: 8px;
}
.b-virtual-scrollers ::-webkit-scrollbar-thumb {
  background: #939393;
  border-radius: 4px;
}
.b-icon-first:before {
  content: '';
}
.b-icon-previous:before {
  content: '';
}
.b-icon-next:before {
  content: '';
}
.b-icon-last:before {
  content: '';
}
.b-grid-row {
  border-bottom: 1px solid #D8D9DA;
  height: 40px !important;
}
.b-grid-row > .b-grid-cell.b-grid-cell.b-grid-cell {
  padding-left: 16px;
  min-height: 40px;
}
.b-grid-header.b-depth-0 {
  padding: 0 16px;
}
.b-grid-header-container {
  border-bottom: 1px solid #D8D9DA !important;
  height: 36px;
}
.b-grid-header-container .b-grid-header .b-grid-header-text {
  min-height: 36px;
}
.b-menu-content.b-popup-content.b-auto-container.b-widget-scroller {
  flex-direction: column;
}
.pulse-bryntum-grid-review-root .b-grid-body-wrap {
  border-radius: 0;
}
.pulse-bryntum-grid-review-root .b-grid-body-wrap .b-header > .b-grid-headers > .b-grid-header {
  padding: 16px 8px 16px 16px;
  min-height: 36px;
}
.pulse-bryntum-grid-review-root .b-grid-row > .b-grid-cell.view-btn {
  padding-right: 8px;
}
.pulse-bryntum-grid-review-root .b-grid-row > .b-grid-cell.view-btn [data-action="view-menu"] {
  border: #CAC9CC solid 1px;
  border: 1px solid #CAC9CC;
}
.pulse-bryntum-grid-review-root .b-grid-row > .b-grid-cell.reviewer-col {
  padding: 8px;
}
.pulse-bryntum-grid-review-root .b-grid-row > .b-grid-cell.source-img-col {
  padding: 5px 8px 5px 16px;
  border-radius: 4px;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-dock-bottom .b-toolbar-content {
  height: 36px;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .review-data-summary {
  font-weight: 500;
  font-size: 12px;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .first-page-button.first-page-button, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .previous-page-button.previous-page-button, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .next-page-button.next-page-button, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .last-page-button.last-page-button {
  height: 24px;
  width: 24px;
  min-width: auto;
  margin-right: 0;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .first-page-button.first-page-button i, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .previous-page-button.previous-page-button i, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .next-page-button.next-page-button i, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .last-page-button.last-page-button i {
  font-size: 12px;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .first-page-button.first-page-button:not([disabled]), .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .previous-page-button.previous-page-button:not([disabled]), .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .next-page-button.next-page-button:not([disabled]), .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .last-page-button.last-page-button:not([disabled]) {
  background: #FFFFFF;
  border-radius: 4px;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .first-page-button.first-page-button:not([disabled]) i, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .previous-page-button.previous-page-button:not([disabled]) i, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .next-page-button.next-page-button:not([disabled]) i, .pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .last-page-button.last-page-button:not([disabled]) i {
  color: #18181A !important;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .rows-per-page-label {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .rows-per-page-combo {
  height: 100%;
  padding: 0;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .page-number {
  color: #626166;
  margin-left: 12px;
  margin-right: 4px;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .page-number label {
  margin-left: 0;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .page-number #review-page-number-input {
  border: 1px #CAC9CC solid;
}
.pulse-bryntum-grid-review-root .b-toolbar.b-pagingtoolbar .page-count {
  margin-right: 12px;
  font-size: 12px;
}
.crxG1N3nVi.crxG1N3nVi.crxG1N3nVi.crxG1N3nVi {
  padding: 4px 8px !important;
  border-right: 1px solid #efefef !important;
}
.y8Xe14EhII {
  filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.16));
}
.WMuSkhMCCd {
  border-radius: 3px;
  height: 30px;
  min-height: 30px;
  width: 40px;
  min-width: 40px;
}
.E_MAGXiP8D[data-empty='true'] {
  padding-bottom: 0 !important;
}
.S2xeyysCds {
  font-size: 16px;
}
.EjVVd_QjtX {
  padding: 8px !important;
}
.EjVVd_QjtX > div {
  width: 100%;
}
.VqRlbFaMzV {
  display: flex;
  align-items: center;
}
.f7E8EvBjis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;
  color: #18181A;
}
.KjVD500x0L {
  font-size: 11px;
}
.KjVD500x0L > div {
  width: 100%;
  display: flex;
}
.aYQHRMeFCF > div {
  justify-content: center;
}
.gOkRoLaq23 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.otHrCJ1WBF {
  text-transform: uppercase;
  font-size: 12px;
}
.RxRTHiFm58 {
  padding: 8px !important;
}
.RxRTHiFm58 > div {
  width: 100%;
}
.mMgeSpWDqD {
  max-width: fit-content;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 11px;
}
.TE69urqygD.TE69urqygD {
  height: 24px;
  width: 24px;
  border: 1px solid #fff;
  margin-right: -8px;
}
.pmAuQWMrM1 {
  font-size: 11px;
  text-transform: uppercase;
}
.pmAuQWMrM1 .O9u3BFaODD {
  font-size: 11px;
  margin-right: 4px;
  color: #EAAC6D;
}
.JBMlfpbdl4 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ZmMZ2Vvx8g.ZmMZ2Vvx8g.ZmMZ2Vvx8g.ZmMZ2Vvx8g {
  margin: -8px 0 0 0;
}
.ZmMZ2Vvx8g.ZmMZ2Vvx8g.ZmMZ2Vvx8g.ZmMZ2Vvx8g > div {
  height: 20px;
  border-radius: 4px;
}
.ZmMZ2Vvx8g.ZmMZ2Vvx8g.ZmMZ2Vvx8g.ZmMZ2Vvx8g > div > div {
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;
  color: #626166;
}
.ZmMZ2Vvx8g.ZmMZ2Vvx8g.ZmMZ2Vvx8g.ZmMZ2Vvx8g > div .BqAv6y2Fcx {
  background: #1BB294;
  color: white;
}
.a0SZdhGiOY.a0SZdhGiOY {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  position: relative;
  padding: 8px;
}
.a0SZdhGiOY.a0SZdhGiOY .iyLJwUPZLb {
  background-color: white;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  color: #000;
  width: 114px;
  font-size: 10px;
  font-weight: normal;
}
.a0SZdhGiOY.a0SZdhGiOY .iyLJwUPZLb:hover {
  background-color: #375A87;
  color: #fff;
}
.a0SZdhGiOY.a0SZdhGiOY .EraXvoyN66 {
  border-radius: 4px;
  margin-left: 4px;
}
.a0SZdhGiOY.a0SZdhGiOY .EraXvoyN66 .uMYpqZDa6s {
  color: #18181A;
}
.a0SZdhGiOY.a0SZdhGiOY .z1cjPlK_Cn {
  background-color: #fff;
  border: 1px solid #DDDDDD;
}
.a0SZdhGiOY.a0SZdhGiOY .z1cjPlK_Cn:hover {
  border: 1px solid #222222;
}
.a0SZdhGiOY.a0SZdhGiOY .QxYVFI5hRr {
  font-size: 32px;
  margin: 0;
}
.a0SZdhGiOY.a0SZdhGiOY .O05lklzfeO {
  color: #18181A;
}
.KakCwBRZQa.KakCwBRZQa {
  padding: 0 !important;
}
.KakCwBRZQa.KakCwBRZQa div:first-child {
  height: 100%;
  padding-top: 4px;
}
.KakCwBRZQa.KakCwBRZQa div:last-child {
  height: 100%;
  padding-bottom: 4px;
}
.KakCwBRZQa.KakCwBRZQa .LavblgQUy9 {
  height: 36px;
}
._ZBfTTNCx5 {
  color: #18181A;
  display: flex;
  gap: 16px;
  padding: 16px;
  overflow: hidden;
  cursor: pointer;
}
._ZBfTTNCx5:hover {
  background: #F2F2F2;
}
._ZBfTTNCx5:not(:last-child) {
  border-bottom: 1px solid #E4E4E6;
}
.GWHquXeQy6 {
  border-radius: 4px;
  height: 30px;
  width: 40px;
}
.GWHquXeQy6 i {
  font-size: 30px;
}
._mUf2WHXQr {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  flex: 1;
  overflow: hidden;
}
._mUf2WHXQr .LucdI2s_cn {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}
._mUf2WHXQr .LucdI2s_cn .kSIasQl8Zj {
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
._mUf2WHXQr .BxoEWgNElm {
  display: flex;
  align-items: center;
  gap: 4px;
}
._mUf2WHXQr .BxoEWgNElm .TToGv7tWZX {
  border: 1px solid #CAC9CC;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 2px;
  height: 20px;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  padding: 2px 8px;
}
._mUf2WHXQr .BxoEWgNElm .TToGv7tWZX span {
  max-width: 60px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
._mUf2WHXQr .BxoEWgNElm .FaTLMctGGN {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-decoration: underline;
}
._mUf2WHXQr .INyVmR_L_T {
  display: flex;
  align-items: center;
  gap: 4px;
}
._mUf2WHXQr .INyVmR_L_T .VNMMuEcJk2 {
  display: flex;
  align-items: center;
}
._mUf2WHXQr .INyVmR_L_T .VNMMuEcJk2 .w1nVcfAqHy {
  border-radius: 100%;
  height: 24px;
  width: 24px;
  border: 1px solid #fff;
}
._mUf2WHXQr .INyVmR_L_T .VNMMuEcJk2 .w1nVcfAqHy:not(:first-child) {
  margin-left: -4px;
}
._mUf2WHXQr .INyVmR_L_T .il8IteiKQz {
  background-color: #E4E4E6;
  border-radius: 100%;
  color: #313033;
  display: flex;
  align-items: center;
  font-size: 11px;
  justify-content: center;
  height: 24px;
  width: 24px;
  margin-left: -4px;
}
._mUf2WHXQr .INyVmR_L_T .jkXUiUVyor {
  margin-bottom: 22px;
}
._mUf2WHXQr .t6JeDlTJk4 {
  color: #626166;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
}
._mUf2WHXQr .WSAyTU6Pmi {
  background-color: #0E8E44;
  border-radius: 10px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  height: 20px;
  min-width: fit-content;
  padding: 2px 8px;
  text-transform: capitalize;
}
._mUf2WHXQr .ewKBG3njHY {
  background-color: #2870C4;
}
.v8osn9a1XE {
  font-size: 12px;
  color: #18181A;
  line-height: 16px;
}
.hBnCVAnU_P {
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.hBnCVAnU_P .nzWvns4pHn.nzWvns4pHn {
  font-weight: 600;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `GFRo5k7Ion`,
	"color-row": `TwNrXwqsy4`,
	"color-tile": `AW9gXy_mqM`,
	"picker-component": `lp5fMkZZUC`,
	"picker-element": `gokO9AZjSS`,
	"active": `k6okVIGihX`,
	"btn": `Aqb9sjRPe9`,
	"red-1": `R7H_hpxN0n`,
	"red-2": `LDQybne1Iq`,
	"red-3": `XYCK0TdahU`,
	"red-4": `A9su_054Gx`,
	"red-5": `NpKc1Kz_pd`,
	"red-6": `RKS19c5KeT`,
	"orange-1": `H68INUgIWp`,
	"orange-2": `plgSxsy9LL`,
	"orange-3": `cSAzkg6p11`,
	"orange-4": `FFJHUyfcXX`,
	"orange-5": `OjuGwbigQO`,
	"orange-6": `sf8CZhYPU3`,
	"green-1": `mflrNT0Tu1`,
	"green-2": `xnpN8yV5kt`,
	"green-3": `ou7WZZCdrB`,
	"green-4": `VljSyFJSEa`,
	"green-5": `pJ9ckYYz8F`,
	"green-6": `HXKGzwvo_B`,
	"blue-1": `CXXwW4Ivqf`,
	"blue-2": `kq8Hnsd3UY`,
	"blue-3": `sWN7eG77Ak`,
	"blue-4": `LCuh0vbUa5`,
	"blue-5": `jO_GlnTwuu`,
	"blue-6": `oyctR0glwM`,
	"yellow-1": `QDGdWCUzrc`,
	"yellow-2": `BmYWT4MgdN`,
	"yellow-3": `jQzCjLEjFW`,
	"yellow-4": `yJ4eOq0nA2`,
	"yellow-5": `N3xsd1Ug4W`,
	"yellow-6": `cpJXGKDbyO`,
	"purple-1": `xrBgRvhBfx`,
	"purple-2": `caIy3E_yhD`,
	"purple-3": `oHO8PRe1r0`,
	"purple-4": `n5qnVBW69M`,
	"purple-5": `jOmzNtj2pH`,
	"purple-6": `iUMnK3we3y`,
	"black-1": `RVtpee7MoM`,
	"black-2": `UtcvSENCac`,
	"black-3": `Q2hUN1QtEI`,
	"black-4": `fv5RqPxJxU`,
	"black-5": `rIPuSpvunH`,
	"black-6": `A3k3VoEQl2`,
	"picker-theme": `Af2jdI5reb`,
	"arrow-regular": `l45EiPTvYI`,
	"review-grid--hidden": `B1vMjMCbPd`,
	"review-cell-text": `alngoCyDDf`,
	"custom-col-image": `crxG1N3nVi`,
	"custom-review-img": `y8Xe14EhII`,
	"default-review-image": `WMuSkhMCCd`,
	"pulse-bryntum-grid-review": `E_MAGXiP8D`,
	"url-thumbnail-icon": `S2xeyysCds`,
	"custom-col-review": `EjVVd_QjtX`,
	"custom-col-review__ellipsis": `VqRlbFaMzV`,
	"custom-col-review__ellipsis--text": `f7E8EvBjis`,
	"custom-col-wrapper": `KjVD500x0L`,
	"custom-col-align": `aYQHRMeFCF`,
	"review-col-ellipsis": `gOkRoLaq23`,
	"review-col-uppercase": `otHrCJ1WBF`,
	"custom-col-project": `RxRTHiFm58`,
	"custom-col-project__ellipsis": `mMgeSpWDqD`,
	"custom-col-reviewer__avatar": `TE69urqygD`,
	"status": `pmAuQWMrM1`,
	"iconStyle": `O9u3BFaODD`,
	"pulse-review-status-rows": `JBMlfpbdl4`,
	"progressStatusRoot": `ZmMZ2Vvx8g`,
	"progressStatusRoot__active": `BqAv6y2Fcx`,
	"groupButton": `a0SZdhGiOY`,
	"viewProof": `iyLJwUPZLb`,
	"action-menu-button__root": `EraXvoyN66`,
	"action-menu-button__icon": `uMYpqZDa6s`,
	"action-menu-button__btn": `z1cjPlK_Cn`,
	"action-menu-button-icon": `QxYVFI5hRr`,
	"view-proof-btn__icon": `O05lklzfeO`,
	"dropdown-button__ctn": `KakCwBRZQa`,
	"dropdown-button__label": `LavblgQUy9`,
	"review-item": `_ZBfTTNCx5`,
	"review-item__image": `GWHquXeQy6`,
	"review-item__content": `_mUf2WHXQr`,
	"review-item__info": `LucdI2s_cn`,
	"review-item__title": `kSIasQl8Zj`,
	"review-item__job": `BxoEWgNElm`,
	"job-number": `TToGv7tWZX`,
	"job-title": `FaTLMctGGN`,
	"review-item__reviewers": `INyVmR_L_T`,
	"reviewer-avatars": `VNMMuEcJk2`,
	"reviewer-avatar": `w1nVcfAqHy`,
	"extra-count": `il8IteiKQz`,
	"review-status": `jkXUiUVyor`,
	"review-item__footer": `t6JeDlTJk4`,
	"review-item__status": `WSAyTU6Pmi`,
	"in_progress": `ewKBG3njHY`,
	"date-created-cell__body": `v8osn9a1XE`,
	"review-status-chip-cell__body": `hBnCVAnU_P`,
	"review-status-chip-cell__label": `nzWvns4pHn`
};
export default ___CSS_LOADER_EXPORT___;
